import {evite} from 'evite';
import * as _Redux from 'node-modules-react-redux';

Object.assign(exports, _Redux);
evite.set(evite, 'exports.ReactRedux', exports);

window.Redux = exports;
